import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const b = localStorage.getItem("roxy_biz");
  if (b) c.headers["X-Business-Id"] = b;
  return c;
});

export const bg = { headers: { "X-Background": "1" } };

api.interceptors.response.use((r) => {
  if (r.config.method !== "get") window.dispatchEvent(new Event("roxy:changed"));
  return r;
}, (e) => {
  if (e?.response?.status === 401 && !String(e.config?.url || "").startsWith("/auth/")) window.dispatchEvent(new Event("roxy:unauth"));
  return Promise.reject(e);
});

export const errMsg = async (e) => {
  let d = e?.response?.data;
  if (d instanceof Blob) {
    try { d = JSON.parse(await d.text()); } catch { d = null; }
  }
  const det = d?.detail;
  if (Array.isArray(det)) return det.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join("; ");
  if (typeof det === "string") return det;
  return e?.message || "Something went wrong";
};

// String-based INR formatting (no float rounding of money)
export const inr = (v, sym = true) => {
  if (v === null || v === undefined || v === "") return "—";
  let s = String(v);
  const neg = s.startsWith("-");
  s = s.replace("-", "");
  let [w, f = "00"] = s.split(".");
  f = (f + "00").slice(0, 2);
  const last3 = w.slice(-3);
  let rest = w.slice(0, -3);
  rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  const out = (rest ? rest + "," : "") + last3 + "." + f;
  return (neg ? "-" : "") + (sym ? "₹" : "") + out;
};

export const shortInr = (n) => {
  const x = Number(n || 0);
  const a = Math.abs(x);
  if (a >= 1e7) return `₹${(x / 1e7).toFixed(2)}Cr`;
  if (a >= 1e5) return `₹${(x / 1e5).toFixed(2)}L`;
  if (a >= 1e3) return `₹${(x / 1e3).toFixed(1)}K`;
  return `₹${x.toFixed(0)}`;
};

export const fmtDate = (d) => {
  if (!d) return "—";
  const [y, m, day] = d.slice(0, 10).split("-");
  return `${day}/${m}/${y}`;
};

export const ageDays = (iso) => (iso ? Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 864e5)) : 0);

export async function download(path, { method = "get", data, params, filename } = {}) {
  const r = await api.request({ url: path, method, data, params, responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const name = filename || (cd.match(/filename="?([^"]+)"?/) || [])[1] || "download";
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
